import React, { useCallback, useMemo, useEffect, useState } from "react";

import PropTypes from 'prop-types';
import { asMoney, deepCopy } from "../../../utils";
import { addWeeks, parse, format } from "date-fns";
import { Link, useOutletContext } from "react-router-dom";
import CampaignStatusPane from './CampaignSummary/CampaignStatusPane';
import CampaignFinancialTable from "./CampaignSummary/CampaignFinancialTable";
import { FixedField } from "../../../components/FixedField";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Button, Checkbox,
    FormControlLabel,
    FormGroup,
    TextField, Tooltip, Radio, RadioGroup, FormControl, FormLabel,
    Box,
    InputAdornment,
    IconButton,
    CircularProgress,
    Alert,
} from "@mui/material";
import { ClientSubTypeSelect } from "../../../components/MaterialSelects/ClientSubTypeSelect";
import { IsoDatePicker } from "../../../components/IsoDatePicker";
import { CurrencySelect } from "../../../components/MaterialSelects/CurrencySelect";
import { SalesTeamSelect } from "../../../components/MaterialSelects/SalesTeamSelect";
import { UserSelect } from "../../../components/MaterialSelects/UserSelect";
import { PostersReceivedSelect } from "../../../components/MaterialSelects/PostersReceivedSelect";
import { useUserContext } from "../../../contexts/user-context";
import { ClientCompanyAndContactSelect } from "../../../components/MaterialSelects/ClientCompanyAndContactSelect";
import { CampaignOutletContextValue } from "../form";
import { ISODateTimeField } from "../../../components/ISODateTimeField";
import { RegionSelectGrouped } from "../../../components/MaterialSelects/RegionSelectGrouped";
import { useDaybookContext } from '../../../contexts/Daybook/DayBookContext';
import { FileInput, FileInputType } from "../../../components/file-input";
import { useExchangeRatesContext } from "../../../contexts/exchange-rates-context";
import { FieldTable } from "../../../components/FieldTable/FieldTable";
import { ContentCopy, OpenInNew, Refresh } from "@mui/icons-material";
import { useRegenerateCampaignNextcloudMutation, useGetCampaignNextcloudUrlsLazyQuery, useGetNextcloudEnabledLazyQuery } from "../../../generated/graphql";
import { useToast } from "../../../contexts/toast";

const CampaignSummary = () => {
    //const [showDialogCancel,setShowDialogCancel] = useState(false);
    //const [showDialogConfirm,setShowDialogConfirm] = useState(false);
    //    const setValue = props.setValue;
    const user = useUserContext();
    const { toast } = useToast();
    const { setValue, onChange, values, errors, loading, readOnly, initialValues, setTab, isReadOnly, transientValues, setTransient } = useOutletContext<CampaignOutletContextValue>();
    useEffect(() => {
        setTab('summary');
    }, []);
    useEffect(() => {
        if (!values?.areaBookings) return;
        const prefix = values?.salesTeam?.prefix;
        const updatedBookings = values.areaBookings.map((booking) => {
            const posterName = booking?.posterSize?.name;
            const isLocalSpecial = ["A 4 Sheet (Local)", "A Quad (Local)", "A 4 Sheet (GD)"].includes(posterName);
            if (isLocalSpecial && prefix !== "JAR" && prefix !== "BHS") {

                return {
                    ...booking,
                    posterSize: null
                };
            }
            return booking;
        });
        if (JSON.stringify(updatedBookings) !== JSON.stringify(values.areaBookings)) {
            setValue("areaBookings", updatedBookings);
        }
    }, [values?.salesTeam?.prefix]);
    const exchangeRatesContext = useExchangeRatesContext();
    const field = {
        onChange: onChange,
        setValue: setValue,
        readOnly: readOnly
    };
    const daybook = useDaybookContext();
    const currency = values?.currency ? values?.currency?.glyph : '£';
    const isNew = values.id === 'new';
    console.log('isNew is', isNew);
    const changeStartDate = useCallback((v) => {
        // default completionDate to startDate+2 weeks, this is one
        // way to do it
        const completionDate = values?.completion_date;
        if (v.target.value && !completionDate) {
            setValue('completion_date', format(addWeeks(parse(v.target.value, 'yyyy-MM-dd', new Date()), 2), 'yyyy-MM-dd'));
        }
        setValue(v.target.name, v.target.value);
    }, [values.completion_date, setValue]);
    const clientCompany = values.clientCompany;
    const clientCompanyContact = values.clientCompanyContact;
    /*const ccChange = useCallback((v) => {
        const value = v.target.value;
        setValue('clientCompany', value?.company);
        console.log('CCHANGE1',value?.company);
        const contact = deepCopy(value.contact);
        delete(contact.clientCompany);
        setValue('clientCompanyContact', contact);
        console.log('CCHANGE2',contact);
    }, [setValue]);*/
    
    useEffect(() => {
        if (daybook?.theme === 'daybook') return;
        const isPTE =
            clientCompany?.sales_company === 'Paper Trails Europe' ||
            clientCompany?.accounts_company === 'Paper Trails Europe';

        if (isPTE && values.currency?.label !== 'EUR') {
            setValue('currency', { id: '1', label: 'EUR', glyph: '€' });
        }
    }, [clientCompany, setValue, values.currency, daybook?.theme]);

    const changeContact = (evt) => {
        const value = evt.target.value;
        if (!value) {
            setValue('clientCompanyContact', null);
        }
        const p = { ...value };
        delete p.clientCompany;
        setValue('clientCompanyContact', p);
        console.log('P2 set CCC to', p, evt);
    };
    const changeCompany = (evt) => {
        const value = evt.target.value;
        if (!value) {
            setValue('clientCompany', null);
        }
        const p = { ...value };
        setValue('clientCompany', p);
        console.log('P2 set CC to', p, evt);
    };
    console.log('CCACSO', clientCompany, clientCompanyContact);
    const clientCompanyFunc = <div className="grid12">
        <ClientCompanyAndContactSelect {...field} fill={true} name="clientCompanyCombo"
            companyValue={clientCompany} contactValue={clientCompanyContact}
            error={!!(errors?.clientCompany || errors?.clientCompanyContact)}
            onChangeCompany={changeCompany}
            onChangeClient={changeContact}
            className="grid12-6" label="Client" />
        {clientCompany &&
            <React.Fragment>
                <FixedField label="Credit Limit" className="grid12-3"
                    value={currency + asMoney(clientCompany.credit_limit) + ' - ' + (clientCompany.current_credit > clientCompany.credit_limit ? ' BAD' : ' OK')} />
                <FixedField label="Client Type" className="grid12-3" value={clientCompany.clientType?.name} />
                {!isNew &&
                    <>
                        <Button className="grid12-3" component={Link} to={'/companies/' + clientCompany.id}>View Client Company
                            details</Button>
                        <Button className="grid12-3" component={Link} to={'/contacts/' + clientCompanyContact?.id}>View Client Contact
                            details</Button>
                    </>
                }
            </React.Fragment>
        }
    </div>;
    let exchangeRatesTable: JSX.Element | null = null;
    if (values.currencies && (values.currencies?.length > 1 && values.status != 'Draft')) {
        const exchangeRateColumns = [
            {
                accessor: 'from.label',
                header: 'From',
                width: 'minmax(8em,max-content)'
            },
            {
                accessor: 'to.label',
                header: 'To',
                width: 'minmax(8em,max-content)'
            },
            {
                accessor: 'rate',
                header: 'Rate',
                width: '1fr',
                className: 'column-left'
            }
        ];
        const currencyTable = [];
        Object.entries(exchangeRatesContext?.exchangeRates ? (exchangeRatesContext.exchangeRates[exchangeRatesContext.targetCurrency?.id] ?? {}) : {}).forEach(
            (er) => {
                const currency = exchangeRatesContext?.options.find((currency) => currency.id == er[0]);
                if (!currency) return null;
                const rate = Number(er[1]);
                currencyTable.push({ from: currency, to: exchangeRatesContext?.targetCurrency, rate: rate.toFixed(3) });
                currencyTable.push({ from: exchangeRatesContext?.targetCurrency, to: currency, rate: (1 / rate).toFixed(3) });
            });

        exchangeRatesTable = <Accordion defaultExpanded={false}>
            <AccordionSummary>Exchange rates ({values.campaignExchangeRates ? 'Fixed when quoted' : 'System'})</AccordionSummary>
            <AccordionDetails>
                <FieldTable columns={exchangeRateColumns} values={currencyTable} readOnly={true} />
            </AccordionDetails>
        </Accordion>
    }

    // A link is "broken" when it ends at /s/ with no token after it,
    // e.g. https://artworkupload.buildhollywood.co.uk/index.php/s/
    const isLinkBroken = (url?: string) => !url || !/\/s\/[^/]+/.test(url);

    const [regenerateNextcloud, { loading: regenerating }] = useRegenerateCampaignNextcloudMutation();

    // Whether the backend has Nextcloud enabled — when false, the whole
    // Nextcloud block (links, regenerate button, waiting state) is hidden.
    // Hidden only on an explicit false; a missing/errored query falls back
    // to the previous (visible) behaviour.
    const [getNextcloudEnabled, { data: nextcloudEnabledData }] = useGetNextcloudEnabledLazyQuery();
    useEffect(() => { getNextcloudEnabled(); }, []);
    const nextcloudHidden = nextcloudEnabledData?.nextcloudEnabled === false;

    const [pollUrls, { data: polledData, stopPolling }] = useGetCampaignNextcloudUrlsLazyQuery({
        fetchPolicy: 'network-only',
    });
    const [waitingForLinks, setWaitingForLinks] = useState(false);
    // Track which campaign ID we triggered regeneration for so we never
    // apply a stale poll result to the wrong campaign after navigation.
    const [regeneratingForId, setRegeneratingForId] = useState<string | null>(null);

    // When polling returns a valid link for THIS campaign, push it into the form and stop
    useEffect(() => {
        const returnedId  = polledData?.campaign?.id;
        const share       = polledData?.campaign?.nextcloud_share_url;
        const view        = polledData?.campaign?.nextcloud_view_url;
        if (returnedId && returnedId === regeneratingForId && share && !isLinkBroken(share)) {
            setValue('nextcloud_share_url', share);
            setValue('nextcloud_view_url', view ?? null);
            stopPolling?.();
            setWaitingForLinks(false);
            setRegeneratingForId(null);
            toast("Artwork links are ready.", { variant: "success" });
        }
    }, [polledData]);

    // Stop polling on unmount to avoid memory leaks and stale updates
    useEffect(() => {
        return () => { stopPolling?.(); };
    }, [stopPolling]);

    const regenerateNextcloudLinks = async () => {
        if (!values.id || values.id === 'new') return;
        try {
            await regenerateNextcloud({ variables: { campaign_id: values.id } });
            // Clear local state immediately so the broken-link button stays visible while we wait
            setValue('nextcloud_share_url', null);
            setValue('nextcloud_view_url', null);
            setRegeneratingForId(values.id);
            setWaitingForLinks(true);
            // Poll every 3 seconds until the job writes back a valid URL (max ~30s = 10 attempts)
            pollUrls({ variables: { id: values.id }, pollInterval: 3000 });
        } catch (e) {
            toast("Failed to queue regeneration. Please try again.", { variant: "error" });
        }
    };

    // Stop polling after 30 seconds as a safety net
    useEffect(() => {
        if (!waitingForLinks) return;
        const timeout = setTimeout(() => {
            stopPolling?.();
            setWaitingForLinks(false);
            setRegeneratingForId(null);
            toast("Links are taking longer than expected — try refreshing the page.", { variant: "warning" });
        }, 30000);
        return () => clearTimeout(timeout);
    }, [waitingForLinks]);

    const copyShareLink = async () => {
        const url = values?.nextcloud_share_url || "";
        if (!url) return;
        try {
            await navigator.clipboard.writeText(url);
            toast("Share link copied to clipboard", { variant: "success" });
        } catch {
            toast("Could not copy link", { variant: "error" });
        }
    };

    return (<>
        <div className="campaign__summary is-scrollable">
            <Accordion defaultExpanded={true}>
                <AccordionSummary>Campaign</AccordionSummary>
                <AccordionDetails>
                    <div className="grid12">
                        <TextField label="Campaign Name" name="name" {...field} value={values.name}
                            error={!!errors?.name} className="grid12-6" />
                        <FixedField label="Job Reference" value={values.job_reference} className="grid12-1" />
                        <ClientSubTypeSelect label="Campaign Sector" name="clientSubType"
                            className="grid12-5" {...field} value={values.clientSubType}
                            error={!!(errors?.clientSubType)} salesTeamPrefix={values?.salesTeam?.prefix} />
                        <TextField label="PO Number" className="grid12-1" name="purchase_order"
                            disabled={readOnly || !values.is_purchase_order_required}
                            value={values.purchase_order ?? ''} {...field} error={!!errors?.purchase_order} />
                        <FormControlLabel className="grid12-1"
                            control={<Checkbox size="small" name="is_purchase_order_required"
                                disabled={readOnly}
                                checked={!!values?.is_purchase_order_required} {...field} />}
                            label="PO Reqd" labelPlacement="end" />
                        {(values.salesTeam?.has_tax) &&
                            <>
                                {!user.hasPermission('campaigns.set_vat_exempt') &&
                                    <Tooltip title="Enabling VAT exempt requires role permission">

                                        <FormControlLabel className="grid12-1"
                                            control={<Checkbox size="small" name="is_vat_exempt"
                                                disabled={true}
                                                checked={!!values.is_vat_exempt} {...field} />}
                                            label="VAT Exempt" labelPlacement="end" />
                                    </Tooltip>
                                }

                                {user.hasPermission('campaigns.set_vat_exempt') && (!values.clientCompany || !values.clientCompany.is_vat_exempt) &&
                                    <Tooltip title="VAT exempt must be enabled on client record">
                                        <FormControlLabel className="grid12-1"
                                            control={<Checkbox size="small" name="is_vat_exempt"
                                                disabled={true}
                                                checked={!!values.is_vat_exempt} {...field} />}
                                            label="VAT Exempt" labelPlacement="end" />
                                    </Tooltip>
                                }
                                {user.hasPermission('campaigns.set_vat_exempt') && values.clientCompany && values.clientCompany.is_vat_exempt &&
                                    <FormControlLabel className="grid12-1"
                                        control={<Checkbox size="small" name="is_vat_exempt"
                                            disabled={readOnly || !user.hasPermission('campaigns.set_vat_exempt')}
                                            checked={!!values.is_vat_exempt} {...field} />}
                                        label="VAT Exempt" labelPlacement="end" />
                                }
                            </>
                        }
                        <CurrencySelect name="currency" value={values.currency} {...field} readOnly={isReadOnly(true)}
                            error={!!errors?.currency} label="Quote Currency" className="grid12-2" />
                        <CurrencySelect multiple={true} name="currencies" value={values.currencies} {...field}
                            error={!!errors?.currencies} size="small" label="Provider Currencies"
                            className="grid12-2" />
                        <TextField name="invoice" label="Invoice" value={values.invoice ?? ''} {...field}
                            error={!!errors?.invoice} className="grid12-2" />
                        <SalesTeamSelect name="salesTeam" {...field} hideTeam="JKA" needsAuth={true} disabled={!isNew}
                            value={values.salesTeam} error={!!errors?.salesTeam} className="grid12-3"
                            label="Sales Team" readOnly={readOnly || !isNew} />
                        <UserSelect {...field} name="ourContact" value={values.ourContact}
                            error={!!errors?.ourContact} label="Account Manager" className="grid12-2" />
                        <IsoDatePicker name="start_date" {...field} value={values.start_date ?? ''}
                            onChange={changeStartDate} error={!!errors?.start_date} label="Start Date"
                            className="grid12-2" readOnlyMode="field" />
                        <IsoDatePicker name="completion_date" {...field} value={values.completion_date ?? ''}
                            error={!!errors?.completion_date} label="Completion Date"
                            className="grid12-2" readOnlyMode="field" />
                        <PostersReceivedSelect valueIsId={true} simpleSelect={true}
                            name="posters_received" {...field} value={values.posters_received}
                            error={!!errors?.posters_received} label="Posters Received"
                            className="grid12-2" />
                        {values?.salesTeam?.prefix === 'BHS' && (
                            <FormControl className="grid12-2" error={!!errors?.sub_teams_scotland}>
                                <FormLabel id="sub-teams-bhs">Sub Teams</FormLabel>
                                <RadioGroup
                                    row
                                    aria-labelledby="sub-teams-bhs"
                                    name="sub_teams_scotland"
                                    {...field}
                                    value={values.sub_teams_scotland ?? ''}
                                >
                                    <FormControlLabel value="jack" control={<Radio disabled={readOnly} />} label="Jack" />
                                    <FormControlLabel value="jackArts" control={<Radio disabled={readOnly} />} label="Jack Arts" />
                                </RadioGroup>
                            </FormControl>
                        )}
                        {user.hasPermission('campaigns.am_revenue') && values?.salesTeam?.supports_regional_am_allocation &&
                            <RegionSelectGrouped {...field} value={values.regionalAmAllocation}
                                name="regionalAmAllocation" label="Regional AM Revenue Allocation"
                                className="grid12-3"
                                error={!!errors?.regionalAmAllocation} />
                        }
                        {!(daybook?.theme === 'daybook') &&
                            <TextField
                                name="sales_job_ref"
                                label="Sales Job Ref (Inter Company Job)"
                                value={values.sales_job_ref ?? ''}
                                {...field}
                                error={!!errors?.sales_job_ref}
                                className="grid12-2"
                            />
                        }
                        <TextField {...field} className="grid12-span grid12-clear" multiline={true} name="notes"
                            value={values.notes ?? ''} error={!!errors?.notes} label="Notes" />
                    </div>
                </AccordionDetails>
            </Accordion>
            <Accordion defaultExpanded={true}>
                <AccordionSummary>Rigging</AccordionSummary>
                <AccordionDetails>
                    <div className="grid12">
                        <ISODateTimeField name="rigging_up_at" label="Rigging Up" className="grid12-3"
                            value={values.rigging_up_at} readOnly={readOnly}
                            error={errors?.rigging_up_at}
                            onChange={(v) => setValue('rigging_up_at', v)} />
                        <ISODateTimeField name="rigging_down_at" label="Rigging Down" className="grid12-3"
                            value={values.rigging_down_at} readOnly={readOnly}
                            error={errors?.rigging_down_at}
                            onChange={(v) => setValue('rigging_down_at', v)} />
                    </div>
                </AccordionDetails>
            </Accordion>
            <Accordion defaultExpanded={false}>
                <AccordionSummary>Invoices</AccordionSummary>
                <AccordionDetails>
                    <FormGroup className="narrow">
                        <FileInput readOnly={readOnly || !user.hasPermission('campaigns.upload_invoice_files')} name="invoiceFiles" label="Upload invoice" maxImageSize={900}
                            multiple={true} showPreview={true} value={values.invoiceFiles}
                            type={FileInputType.File} fileType="IV" {...field} allowDelete={user.hasPermission('campaigns.delete_invoice_files')} />
                    </FormGroup>
                </AccordionDetails>
            </Accordion>
            {exchangeRatesTable}
            <Accordion defaultExpanded={false}>
                <AccordionSummary>Artwork</AccordionSummary>
                <AccordionDetails>
                    <FormGroup className="narrow">
                        <FileInput isDistributor={!(daybook?.theme === 'daybook')} readOnly={readOnly} name="artworkFiles" label="Upload artwork" maxImageSize={900}
                            multiple={!(daybook?.theme === 'daybook')} showPreview={true} value={values.artworkFiles}
                            type={FileInputType.Image} fileType="AR" {...field} allowDelete={user.hasPermission('campaigns.delete_artwork_files')} />
                    </FormGroup>
                    {values?.nextcloud_share_url && !nextcloudHidden && (
                        <Box mt={2} display="grid" gap={2}>
                            {isLinkBroken(values.nextcloud_share_url) && (
                                <Alert severity="warning">
                                    The artwork link looks incomplete. Use the button below to regenerate it.
                                </Alert>
                            )}
                            <Box>
                                <FormLabel>Share link for clients to upload artwork</FormLabel>
                                <TextField
                                    size="small"
                                    fullWidth
                                    value={values.nextcloud_share_url}
                                    InputProps={{
                                        readOnly: true,
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <Tooltip title="Copy link">
                                                    <IconButton edge="end" onClick={copyShareLink} aria-label="Copy share link">
                                                        <ContentCopy />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title="Open in new tab">
                                                    <IconButton
                                                        edge="end"
                                                        component="a"
                                                        href={values.nextcloud_share_url}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        aria-label="Open share link"
                                                    >
                                                        <OpenInNew />
                                                    </IconButton>
                                                </Tooltip>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Box>

                            <Box>
                                <FormLabel>View link for internal teams</FormLabel>
                                <TextField
                                    size="small"
                                    fullWidth
                                    value={values.nextcloud_view_url}
                                    InputProps={{
                                        readOnly: true,
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <Tooltip title="Open in new tab">
                                                    <IconButton
                                                        edge="end"
                                                        component="a"
                                                        href={values.nextcloud_view_url}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        aria-label="Open internal view link"
                                                    >
                                                        <OpenInNew />
                                                    </IconButton>
                                                </Tooltip>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Box>
                        </Box>
                    )}
                    {!isNew && !readOnly && !nextcloudHidden && isLinkBroken(values.nextcloud_share_url) && (
                        <Box mt={2}>
                            <Tooltip title={waitingForLinks ? "Waiting for Nextcloud…" : "No valid artwork link found — click to generate"}>
                                <span>
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        color="warning"
                                        startIcon={<CircularProgress size={14} style={{ display: regenerating || waitingForLinks ? undefined : 'none' }} />}
                                        endIcon={!regenerating && !waitingForLinks ? <Refresh /> : undefined}
                                        onClick={regenerateNextcloudLinks}
                                        disabled={regenerating || waitingForLinks}
                                    >
                                        {regenerating ? "Queuing…" : waitingForLinks ? "Generating links…" : "Regenerate Artwork Links"}
                                    </Button>
                                </span>
                            </Tooltip>
                        </Box>
                    )}
                </AccordionDetails>
            </Accordion>
            <Accordion defaultExpanded={true}>
                <AccordionSummary>Client</AccordionSummary>
                <AccordionDetails>
                    {clientCompanyFunc}
                </AccordionDetails>
            </Accordion>
            <Accordion defaultExpanded={false}>
                <AccordionSummary>Financial Summary</AccordionSummary>
                <AccordionDetails>
                    <CampaignFinancialTable values={values} readOnly={readOnly} onChange={onChange}
                        loading={loading} isReadOnly={isReadOnly} />
                </AccordionDetails>
            </Accordion>
            {(!isNew || loading) &&
                <Accordion defaultExpanded={true}>
                    <AccordionSummary>Campaign Status</AccordionSummary>
                    <AccordionDetails>
                        <CampaignStatusPane initialValues={initialValues} readOnly={readOnly} values={values}
                            setValue={setValue} onChange={onChange} errors={errors}
                            loading={loading}
                            transientValues={transientValues}
                            setTransient={setTransient}
                        />
                    </AccordionDetails>
                </Accordion>
            }
        </div>
    </>
    );
};

CampaignSummary.propTypes = {
    financialTable: PropTypes.element,
    values: PropTypes.object,
    setValue: PropTypes.func
};

export default CampaignSummary;